<ng-template #overlayTemplate>
  <rt-drawer
    rtDrawerResize
    [rtDrawerResizeBoundaries]="[widthConfig.minWidth, widthConfig.maxWidth]"
    (drawerSizeChanges)="this.drawerSizeChanges.emit()"
    [class.visibility-transition]="(visibilityTransition$ | ngrxPush) === DrawerState.Open"
    [style.width.px]="widthConfig.defaultWidth"
  >
    <rt-drawer-drag-handle />
    <div class="content-container">
      <ng-content></ng-content>
    </div>
  </rt-drawer>
</ng-template>
